import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Box)<{ $isMetricsLine: boolean }>(
  ({ $isMetricsLine }) => ({
    position: "relative",
    width: `${$isMetricsLine ? "calc(100% - 27px)" : "100%"}`,
  })
);

const SCROLL_ARROW_INSET = 28;

export const ScrollContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$paddingLeft" && prop !== "$paddingRight",
})<{
  $paddingLeft?: boolean;
  $paddingRight?: boolean;
}>(({ $paddingLeft = false, $paddingRight = false }) => ({
  width: "100%",
  overflowX: "auto",
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  paddingLeft: $paddingLeft ? SCROLL_ARROW_INSET : 0,
  paddingRight: $paddingRight ? SCROLL_ARROW_INSET : 0,
  "&::-webkit-scrollbar": {
    display: "none",
  },
}));

export const ScrollArrow = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  color: theme.palette.text.primary,
  transform: "translateY(-50%)",
  borderRadius: "20px",
  border: `1px solid ${theme.palette.grey.A400}`,
  backgroundColor: theme.palette.background.paper,
  width: "20px",
  height: "20px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1,
  cursor: "pointer",

  svg: {
    width: "15px",
    height: "15px",
  },

  "&.left": {
    left: 0,
  },

  "&.right": {
    right: 0,
  },
}));
